import React from "react";
import { useParams } from "react-router";
import { useGetOrderDetailQuery } from "./queries";
import ContentWrapper from "../../components/layout/ContentWrapper";
import OrderInfoBox from "./components/detail/OrderInfoBox";
import OrderServiceObjectsTable from "./components/detail/OrderServiceObjectsTable";
import OrderInterventionsTable from "./components/detail/OrderInterventionsTable";
import OrderCustomReportDocumentsTable from "./components/detail/OrderCustomReportDocumentsTable";
import { AttachmentsGallery, PageHeading } from "../../components";

type OrderRouteParams = "orderId";

const OrderDetailPage: React.FC = (): React.ReactElement => {
  const params = useParams<OrderRouteParams>();

  const query = useGetOrderDetailQuery(params.orderId);

  const orderDetail = query.data?.order;

  return (
    <ContentWrapper
      loading={query.isLoading || !orderDetail}
      htmlTitle={orderDetail?.code}
    >
      {orderDetail && (
        <>
          <PageHeading
            backButtonPath="orders"
            title={orderDetail.code}
            className="sm:mb-7"
          />
          <OrderInfoBox orderDetail={orderDetail} />
          <OrderServiceObjectsTable orderDetail={orderDetail} />
          <OrderInterventionsTable orderDetail={orderDetail} />
          <OrderCustomReportDocumentsTable orderId={orderDetail.id} />
          <AttachmentsGallery attachments={orderDetail.attachments || []} />
        </>
      )}
    </ContentWrapper>
  );
};

export default OrderDetailPage;
